{
	"all": "Tout",
	"emptyMessage": "Pas de produit trouvé",
	"mountable": "Combinable",
	"price": "Prix",
	"product": "Produit",
	"sku": "SKU"
}
